import { useMemo } from 'react'
import { SubmitPetsInfoRequest } from '../../../@types/SubmitPetsInfo'
import { ENV } from '../../../Environment'
import { useAnimalStore } from '../../../Stores/animalStore'
import { useAgent } from '../../../Stores/useAgent'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'

export const useSubmitPetsInfoPayload = () => {
  const { agentIdBySessionStorage } = useAgent()
  const { animalsList } = useAnimalStore()
  const { createProposal } = useCreateProposalStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()

  const runPetis = runPetisSimulation?.runPetisSimulationResponse

  const submitPetsInfoPayload: SubmitPetsInfoRequest = useMemo(
    () => ({
      proposalId: createProposal?.createProposalResponse?.proposalId || '',
      coreId: ENV().CoreSystem,
      agentId: agentIdBySessionStorage || '',
      operationType: 'E', //TODO: verificar este dado, onde pegar esse valor?
      policyType: '0', //TODO: verificar este dado, onde pegar esse valor?
      protocolCode: '0', //TODO: verificar este dado, onde pegar esse valor?
      pets: animalsList.map((pet) => {
        const insured = runPetis?.insuredObjectGroup?.insuredObjects?.find(
          (item) => item.insuredObjectSequence === Number(pet.id.at(-1)),
        )

        return {
          id: pet.id.toString(),
          sequenceId: insured?.insuredObjectSequence as never,
          genderCode: pet.gender || '',
          chipNr: pet.chipNumber || '',
          municipalLicenseNr: pet.licenseNumber || '',
        }
      }),
    }),
    [animalsList],
  )

  return {
    submitPetsInfoPayload,
  }
}
